export default "/images/vendor/flag-icon-css/flags/1x1/gt.svg?3d87ccc4e82ef502f1dd9f09414eb509";